import type { ReactNode } from 'react';

import { Spinner } from '@/components/ui/spinner';

import { useGetSessionQuery } from '../services/authApi';
import { useAuth } from '../hooks/useAuth';

/**
 * Resolves the session once, before any route renders.
 *
 * Without this gate, a page refresh on a protected route would briefly see
 * `isAuthenticated === false` — the session probe has not returned yet — and
 * bounce the user to the login screen even though they are signed in.
 */
export function SessionGate({ children }: { children: ReactNode }) {
  // Fires the probe; the auth slice reduces the result via matchers.
  useGetSessionQuery();

  const { isSessionResolved } = useAuth();

  if (!isSessionResolved) {
    return (
      <div className="flex min-h-dvh items-center justify-center">
        <Spinner size="lg" label="Checking your session" />
      </div>
    );
  }

  return <>{children}</>;
}
